import { objectMap } from '../../utils';

/**
 * Constants for local storage keys
 * @module constants/local-storage-keys
 */

const addRoot = (r: string) => (v: unknown): string => `${r}_${v}`;

const rootMap = <T extends Record<string, unknown>>(r: string, o: T) => objectMap(o, addRoot(r));

/**
 * Constants for table settings
 */
const TABLE = Object.freeze(
  rootMap('TABLE', {
    ROWS_PER_PAGE: `ROWS_PER_PAGE`,
    SORT: `SORT`,
  }),
);

/**
 * User settings specific to each page
 */
export const USER = Object.freeze(
  rootMap('USER', {
    TABLE,
  }),
);

/**
 * Global values shared across the application
 */
export const GLOBAL = Object.freeze(
  rootMap('GLOBAL', {
    /**
     * user settings
     */
    USER,
  }),
);
